import React, { useState } from "react";
import "./App.css";

function App() {
  const [messages, setMessages] = useState([]);
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!prompt.trim()) return;

    const newMsg = { sender: "user", text: prompt };
    setMessages([...messages, newMsg]);
    setPrompt("");
    setLoading(true);

    try {
      const res = await fetch("http://localhost:5000/api/prompt", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ prompt }),
      });

      const data = await res.json();
      const botMsg = { sender: "bot", text: data.text || "No response" };
      setMessages((prev) => [...prev, botMsg]);
    } catch (err) {
      console.error("Error:", err);
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "⚠️ Error fetching response." },
      ]);
    }

    setLoading(false);
  };

  // Simple function to render code nicely
  const renderMessage = (msg, idx) => {
    // If response has code blocks (```), split them
    const parts = msg.text.split(/```/);
    return (
      <div key={idx} className={`message ${msg.sender}`}>
        {parts.map((part, i) =>
          i % 2 === 1 ? (
            <pre key={i} className="code-block">
              <code>{part}</code>
            </pre>
          ) : (
            <p key={i}>{part}</p>
          )
        )}
      </div>
    );
  };

  return (
    <div className="app-container">
      <h1 className="chat-heading">
        <img
          src="https://img.icons8.com/skeuomorphism/32/gemini-ai.png"
          alt="gemini-ai"
          className="gemini-icon"
        />
        <span>Gemini Chat</span>
      </h1>

      <div className="chat-box">
        {messages.map((msg, idx) => renderMessage(msg, idx))}
        {loading && <p className="bot message">Thinking...</p>}
      </div>
      <form className="input-box" onSubmit={handleSubmit}>
        <textarea
          rows="2"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="Type your message..."
        />
        <button type="submit" disabled={loading}>
          Send
        </button>
      </form>
    </div>
  );
}

export default App;
